module.exports = __webpack_public_path__ + "static/media/icon_menu_ship.57e4cddb.svg";